"use strict";

import { CONSTANTS } from "~/helpers/constants";

import { getElement } from "~/utils/dom";
import { allowOneDetailsOpen, applyTemplate, combineCheckboxes, formatExpiry, logCookiedockError } from "~/helpers";

import html from "~/ui/main.html?raw";
import preferencesHtml from "~/ui/elements/preferences.html?raw";
import dialogPreferencesHtml from "~/ui/elements/dialog-preferences.html?raw";
import purposesHtml from "~/ui/elements/purposes.html?raw";

import type { CookiePurpose, Content } from "~/types";

export function injectCookiedockDOM(content: Content, cookie_purposes: CookiePurpose[]) {
  try {
    const bannerHtml = applyTemplate(html, content);

    document.body.insertAdjacentHTML("beforeend", bannerHtml);
    processDynamicContent(content, cookie_purposes);
    setupDialogBehavior();
  } catch (error) {
    logCookiedockError(CONSTANTS.CONSOLE.UNABLE_TO_INSERT_HTML);
  }
}

function processDynamicContent(content: Content, purposes: CookiePurpose[]) {
  processPreferences(purposes);
  processDialogPreferences(purposes, content.mandatory);
  processCookiePurposes(purposes);
  combineCheckboxes();
}

function processPreferences(purposes: CookiePurpose[]) {
  const checkboxElements = getElement<HTMLDivElement>(".cdx-checkbox", document, true);
  const preferencesContent = purposes
    .map(({ id, category, mandatory }) =>
      applyTemplate(
        preferencesHtml,
        {
          category,
          id: id.toString(),
          BANNER_PREFERENCES: CONSTANTS.PREFERENCES.BANNER,
          BANNER_SELECTOR: CONSTANTS.BANNER.SELECTOR,
        },
        {
          mandatory: mandatory,
        },
      ),
    )
    .join("");

  checkboxElements.forEach((element) => {
    element.innerHTML += preferencesContent;
  });
}

function processDialogPreferences(purposes: CookiePurpose[], mandatory_text: string) {
  const bodyElements = getElement<HTMLDivElement>(".cdx-body", document, true);

  const dialogContent = purposes
    .map(({ category, mandatory, description }) =>
      applyTemplate(
        dialogPreferencesHtml,
        {
          category,
          DIALOG_PREFERENCES: CONSTANTS.PREFERENCES.DIALOG,
          BANNER_PURPOSES: CONSTANTS.BANNER.PURPOSES,
          BANNER_SELECTOR: CONSTANTS.BANNER.SELECTOR,
          mandatory_text: mandatory_text,
          description: description,
        },
        {
          mandatory: mandatory,
        },
      ),
    )
    .join("");

  bodyElements.forEach((element) => {
    element.innerHTML += dialogContent;
  });

  allowOneDetailsOpen(".cdx-details");
}

function processCookiePurposes(purposes: CookiePurpose[]) {
  purposes.forEach(({ category, detected_cookies }) => {
    const element = getElement<HTMLDivElement>(`.${CONSTANTS.BANNER.PURPOSES}.${category}`, document, false);

    if (!element || element.classList.contains("empty") || detected_cookies.length === 0) {
      return;
    }

    const purposesContent = detected_cookies
      .map(({ cookie_name, automatic_detected, expiry, cookie, description }) => {
        return applyTemplate(purposesHtml, {
          cookie_name,
          automatic_detected: automatic_detected.toString(),
          expiry: formatExpiry(expiry),
          description: description ?? cookie?.description ?? "",
        });
      })
      .join("");

    element.innerHTML += purposesContent;
  });
}

function setupDialogBehavior() {
  const dialog = getElement<HTMLDialogElement>("#cdx__dialog", document, false);
  if (dialog) {
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }
}
